/**
 * Created by tschrader on 19.04.2017.
 * Original Code by Endel Dreyer
 */

Object.defineProperty(Object.prototype, "bindFunction", {
    enumerable: false,
    writable: true,
    value: function(func: Function) {
        // catching wrong inputs
        if (func === null || func === undefined) {
            return func;
        }

        if (typeof func !== "function") {
            throw new Error(`Parameter "func" is not a funciton`);
        }

        if (!this._bindFunction_boundFunctions) {
            this._bindFunction_boundFunctions = new WeakMap<Function, Function>();
        }

        if (!this._bindFunction_boundFunctions.has(func)) {
            this._bindFunction_boundFunctions.set(func, func.bind(this));
        }

        // adding a debug variable to make it possible to find out which functions are not bound (for debugging only)
        let boundFunction:Function = this._bindFunction_boundFunctions.get(func) as Function;
        boundFunction.functionIsBound = true;

        return boundFunction;
    }
});


interface Function {
    functionIsBound: boolean;
}

interface Object {
    _bindFunction_boundFunctions: WeakMap<Function, Function> | undefined;
    bindFunction<T extends Function>(fn: T): T;
}
